import { render, staticRenderFns } from "./QMS.vue?vue&type=template&id=0493d9dd&"
import script from "./QMS.vue?vue&type=script&lang=js&"
export * from "./QMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports